<template>
	<div class="table-sortable">
		<div id="search" v-show="showSearchBar == null || showSearchBar">
			<div class="container">
				<div class="content">
					<div class="search-inner">
						<div class="input-wrapper">
							<input type="text" :value="searchQuery" @input="searchQuery=$event.target.value" :placeholder="computedPlaceholder">
							<span @click="erase" v-if="searchQuery.length" id="erase">
								<svg class="navigation-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M19 6.4L17.6 5 12 10.6 6.4 5 5 6.4l5.6 5.6L5 17.6 6.4 19l5.6-5.6 5.6 5.6 1.4-1.4-5.6-5.6z"/></svg>
							</span>
						</div>
						<!-- <span @click="erase" id="filters">
							<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M3 17v2h6v-2H3zM3 5v2h10V5H3zm10 16v-2h8v-2h-8v-2h-2v6h2zM7 9v2H3v2h4v2h2V9H7zm14 4v-2H11v2h10zm-6-4h2V7h4V5h-4V3h-2v6z"/></svg>
						</span> -->
					</div>
				</div>
			</div>
		</div>
		<div id="actions" v-show="selection" ref="actions">
			<div class="container">
				<div class="content">
					<div class="actions-inner">
						<div class="actions actions-left">
							<span @click="clearSelection();" class="action link-icon"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M19 6.4L17.6 5 12 10.6 6.4 5 5 6.4l5.6 5.6L5 17.6 6.4 19l5.6-5.6 5.6 5.6 1.4-1.4-5.6-5.6z"></path><path d="M0 0h24v24H0z" style="fill: none;"></path></svg></span>
							<span class="action">
								{{selected.length}}
							</span>
						</div>
						<div class="actions actions-right">
							<span class="action link-icon" @click="clickSelectAll">
								<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M3 5h2V3c-1.1 0-2 .9-2 2zm0 8h2v-2H3v2zm4 8h2v-2H7v2zM3 9h2V7H3v2zm10-6h-2v2h2V3zm6 0v2h2c0-1.1-.9-2-2-2zM5 21v-2H3c0 1.1.9 2 2 2zm-2-4h2v-2H3v2zM9 3H7v2h2V3zm2 18h2v-2h-2v2zm8-8h2v-2h-2v2zm0 8c1.1 0 2-.9 2-2h-2v2zm0-12h2V7h-2v2zm0 8h2v-2h-2v2zm-4 4h2v-2h-2v2zm0-16h2V3h-2v2zM7 17h10V7H7v10zm2-8h6v6H9V9z"/></svg>
							</span>
							<span class="action link-icon" v-if="deleteAction" @click="remove">
								<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM8 9h8v10H8V9zm7.5-5l-1-1h-5l-1 1H5v2h14V4z"/></svg>
							</span>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="container">
			<table class="grid">
				<thead v-show="showHeader == null || showHeader">
					<tr v-draggable="computedColumns">
						<th class="checkbox"><label for="selectAllCheckbox"><input type="checkbox" id="selectAllCheckbox" :checked="allItemsSelected" @change="clickSelectAll"></label></th>
						<!--must be wrapped in template tag for draggable to work-->
						<template v-for="(column, index) in computedColumns">
							<th :key="'column-' + index" is="table-head" :column="column" :sort="sort" @sortColumn="sortCol"></th>
						</template>
					</tr>
				</thead>
				<tbody>
					<tr
						is="row-item"
						v-for="(item, index) in filteredData"
						:key="'item-' + index"
						:item="item"
						:index="index"
						:columns="computedColumns"
						:selected="itemSelected(item)"
						@longTapItem="longTapItem"
						@selectItem="selectItem"
						@deselectItem="deselectItem"
						@clickItem="clickItem"
						:class="[{selected: selected.includes(item)}]"
					>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</template>

<script>
import Vue from 'vue'
import Sortable from 'sortablejs'


const tableHead = {
	template: `
		<th 
			v-show="!column.hide"
			:class="{draggable: column.canMove}"
			@click="onClick({column: column, event: true})"
		>
			<div class="th-inner">
				{{column.name}}
				<span class="sortable-icon" v-if="column.sortable && sort.on === column.id">
					<svg v-if="sort.direction === 'asc'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1792 1792"><path d="M736 1440q0 12-10 24l-319 319q-10 9-23 9-12 0-23-9l-320-320q-15-16-7-35 8-20 30-20h192v-1376q0-14 9-23t23-9h192q14 0 23 9t9 23v1376h192q14 0 23 9t9 23zm1056 128v192q0 14-9 23t-23 9h-832q-14 0-23-9t-9-23v-192q0-14 9-23t23-9h832q14 0 23 9t9 23zm-192-512v192q0 14-9 23t-23 9h-640q-14 0-23-9t-9-23v-192q0-14 9-23t23-9h640q14 0 23 9t9 23zm-192-512v192q0 14-9 23t-23 9h-448q-14 0-23-9t-9-23v-192q0-14 9-23t23-9h448q14 0 23 9t9 23zm-192-512v192q0 14-9 23t-23 9h-256q-14 0-23-9t-9-23v-192q0-14 9-23t23-9h256q14 0 23 9t9 23z"/></svg>
					<svg v-else-if="sort.direction === 'desc'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1792 1792"><path d="M1216 1568v192q0 14-9 23t-23 9h-256q-14 0-23-9t-9-23v-192q0-14 9-23t23-9h256q14 0 23 9t9 23zm-480-128q0 12-10 24l-319 319q-10 9-23 9-12 0-23-9l-320-320q-15-16-7-35 8-20 30-20h192v-1376q0-14 9-23t23-9h192q14 0 23 9t9 23v1376h192q14 0 23 9t9 23zm672-384v192q0 14-9 23t-23 9h-448q-14 0-23-9t-9-23v-192q0-14 9-23t23-9h448q14 0 23 9t9 23zm192-512v192q0 14-9 23t-23 9h-640q-14 0-23-9t-9-23v-192q0-14 9-23t23-9h640q14 0 23 9t9 23zm192-512v192q0 14-9 23t-23 9h-832q-14 0-23-9t-9-23v-192q0-14 9-23t23-9h832q14 0 23 9t9 23z"/></svg>
				</span>
			</div>
		</th>`,
	props: ['column', 'sort'],
	methods: {
		onClick(data) {
			this.$emit('sortColumn', data);
		}
	}
};

const rowItem = {
	template: `
		<tr v-touch:longtap="onLongTap" @click="onClick">
			<td class="checkbox"><label :for="'select-'+index"><input type="checkbox" :id="'select-'+index" @change="onChange" :checked="selected"></label></td>
			<template v-for="column in columns">
				<td v-show="!column.hide">{{item[column.id]}}</td>
			</template>
		</tr>
	`,
	props: ['item', 'columns', 'index', 'selected'],
	methods: {
		onLongTap() {
			this.$emit('longTapItem', this.item);
		},
		onClick() {
			this.$emit('clickItem', this.item);
		},
		onChange(e) {
			let checked = e.target.checked;
			if (checked) this.$emit('selectItem', this.item);
			else this.$emit('deselectItem', this.item);
		},
	}
};

export default {
	name: 'SortableTable',
	props: ['click', 'placeholder','filterAttributes', 'deleteAction',
			'columns', 'items', 'sort', 'showSearchBar', 'showHeader'],
	data() {
		let computedColumns = [...this.columns];
		let computedItems = [...this.items];
		return {
			searchQuery: '',
			selected: [],
			computedItems: computedItems,
			computedColumns: computedColumns,
		}
	},
	components: {
		'table-head': tableHead,
		'row-item': rowItem,
	},
	watch: {
		columns: {
			handler(newValue) {
				this.computedColumns = [...newValue];
			},
			deep: true
		},
		items: {
			handler(newValue) {
				this.computedItems = [...newValue];
			},
			deep: true
		},
	},
	computed: {
		selection() {
			return this.selected.length > 0;
		},
		itemSelected() {
			return item => this.selected.includes(item);
		},
		allItemsSelected() {
			return this.selected.length == this.filteredData.length;
		},
		computedPlaceholder() {
			if (this.placeholder) return this.placeholder;
			if (this.$t) return this.$t('search');
			return 'Search';
		},
		filteredData() {
			let self = this;
			//https://vuejs.org/examples/grid-component.html
			let filterKey = self.searchQuery && self.searchQuery.toLowerCase();
			let data = self.computedItems;
			let cols = self.computedColumns;
			if (filterKey) {
				data = data.filter((row) => {
					return cols.reduce((accumulator, col) => {
						if (accumulator || !col.id) {
							return accumulator;
						}
						let colVal = col.id;

						return (
							String(getProp(row, colVal)).toLowerCase().indexOf(filterKey) > -1
						);
					}, false);
				});
			}
			return data;
		},
	},
	methods: {
		erase() {
			this.searchQuery = '';
		},
		clickItem(item) {
			let self = this;
			if (self.selection) {
				if (!self.itemSelected(item)) {
					self.selectItem(item);
				} else {
					self.deselectItem(item);
				}
			} else {
				if (self.click) self.click(item);
			}
		},
		longTapItem(item) {
			let self = this;
			if (!self.selection) {
				self.selectItem(item);
				if (navigator.vibrate){
					navigator.vibrate([100]);
				}
			} else {
				self.clickItem(item);
			}
		},
		selectItem(item) {
			this.selected.push(item);
		},
		deselectItem(item) {
			this.selected = this.selected.filter(o => o != item);
		},
		clickSelectAll() {
			if (!this.allItemsSelected) {
				this.selectAll();
			} else {
				this.clearSelection();
			}
		},
		selectAll() {
			let self = this;
			self.filteredData.forEach((item) => {
				if (!self.itemSelected(item)) {
					self.selected.push(item);
				}
			});
		},
		clearSelection() {
			this.selected = [];
		},
		remove() {
			let self = this;
			this.deleteAction(this.selected)
			.then(() => {
				// self.list = self.list.filter(o => !self.selected.includes(o));
			})
			.catch((err) => {

			})
			.then(() => {
				self.clearSelection();
			});
		},
		sortCol(data) {
			let self = this;
			let column = data.column;
			if (!column.sortable) return;

			//respond to click vs set from settings
			if (data.event) {
				//change sort order
				if (self.sort.on === column.id) {
					//change sort order
					if (self.sort.direction === "desc" || !self.sort.direction) {
						self.sort.direction = "asc";
					} else {
						self.sort.direction = "desc";
					}
				} else {
					//change sort column, default to asc
					self.sort.on = column.id;
					self.sort.direction = "asc";
					self.sort.type = column.type;
				}
			}

			let direction = self.sort.direction;
			let on = self.sort.on;
			let type = self.sort.type; //fixme implement search functions per type

			self.computedItems.sort((a, b) => {
				if (direction === 'asc') {
					return String(getProp(a, on)).localeCompare(String(getProp(b, on)), undefined, {numeric: type === 'numeric'});
				} else if (direction === 'desc') {
					return String(getProp(b, on)).localeCompare(String(getProp(a, on)), undefined, {numeric: type === 'numeric'});
				}
			});
		},
	},
	directives: {
		draggable: {
			inserted: function(el, binding, a) {
				let self = this;
				Sortable.create(el, {
					draggable: '.draggable',
					onEnd: function(e) {
						let clonedItems = [...a.context[binding.expression]];
						clonedItems.splice(e.newIndex, 0, clonedItems.splice(e.oldIndex, 1)[0]);
						a.context[binding.expression] = [];
						a.context.$nextTick(() => {
							a.context[binding.expression] = clonedItems;
						});
					}
				});
			}
		}
	},
}
</script>


<style scoped>
#search {
	background: #aaa;
}

#search .search-inner {
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 1.2rem 0;
}

#search .input-wrapper {
	position: relative;
	width: 100%;
}

#search input {
	margin: 0;
	border: none;
	background: #ccc;
	border-radius: 2.8rem;
	height: 2.8rem;
}

#search #erase {
	position: absolute;
	display: flex;
	justify-content: center;
	align-items: center;
	width: 2.8rem;
	height: 2.8rem;
	border-radius: 50%;
	top: 0;
	right: 0;
	cursor: pointer;
	background: #aaa;
	border: .2rem solid #ccc;
}

#search #erase:hover,
#search #erase:focus {
	background: #999;
}

#search #erase svg {
	width: 2.4rem;
	height: 2.4rem;
	margin: 0;
}

#search #erase path {
	fill: #fff;
}

#search #filters {
	display: flex;
	justify-content: center;
	align-items: center;
	width: 2.8rem;
	height: 2.8rem;
	border-radius: 50%;
	cursor: pointer;
/*	background: #ccc;
	border: .2rem solid #ccc;*/
	margin-left: 1.6rem;
}

#search #filters:hover,
#search #filters:focus {
	border-color: #ccc;
	background: #ccc;
}

#search #filters path {
	fill: #fff;
}

#actions {
	position: sticky;
	top: 0;
	z-index: 300;
	width: 100%;
	padding: 1.6rem 0;
	background-color: var(--primary_color);
	color: var(--inverse_text_color);
	font-size: 2.4rem;
	line-height: 4.0rem;
}

#actions path {
	fill: var(--inverse_text_color);
}

#actions .actions {
	display: flex;
	align-items: center;
}

#actions .actions-inner {
	display: flex;
	justify-content: space-between;
	align-items: center;
}

#actions .action + .action:not(.link-icon) {
	margin-left: .8rem;
}

#actions svg {
	width: 2.4rem;
	height: 2.4rem;
}

.draggable {
	cursor: move;
}

table {
	border-collapse: collapse;
	width: 100%;
}

table >>> td,
table >>> th {
	padding: .8rem !important;
}

table >>> .th-inner {
	position: relative;
	display: flex;
	justify-content: space-between;
	align-items: center;
}

table >>> .sortable-icon {
	position: absolute;
	top: 50%;
	right: 0;
	transform: translateY(-50%);
	display: flex;
}

table >>> .sortable-icon svg {
	width: 1.6rem;
	height: 1.6rem;
}

table >>> tr.selected {
	background-color: var(--inverse_color);
	color: var(--inverse_text_color);
}

.sortable-ghost {
	background: #1c72c7;
	color: #FFF;
	opacity: .5;
}

.sortable-chosen {
	background: #1c72c7;
	color: #FFF;
}

.sortable-fallback {
	background: #1c72c7;
	color: #FFF;
	opacity: .3;
	border-color: transparent;
}

table >>> th.checkbox,
table >>> td.checkbox {
	position: relative;
}

table >>> th.checkbox label,
table >>> td.checkbox label {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
	margin: 0;
	cursor: pointer;
}

table >>> th.checkbox input[type="checkbox"],
table >>> td.checkbox input[type="checkbox"] {
	margin: 0;
	height: auto !important;
	cursor: pointer;
}
</style>